import React from 'react';
import { TypedMemo } from '../../../../../common/types';
import { useDateRedo } from './useDateRedo';
import { DateRedoPanel } from './DateRedoPanel';
/* eslint-disable css-modules/no-unused-class -- the stylesheet of the cover redo; this part uses its posts slot */
import styles from '../coverRedo/CoverRedo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The date redo banner over the Posts board of a release: most files with a date are posts. */
const ReleasePostsDateRedoComponent: React.FC<{ accountId: number; catalogItemUuid: string }> = ({
  accountId,
  catalogItemUuid,
}) => {
  const redo = useDateRedo({ accountId, catalogItemUuid });
  if (redo.banner === 'hidden' && !redo.showsQuietLine && redo.beforeRelease.length === 0) {
    return null;
  }
  return (
    <div className={styles.postsSlot}>
      <DateRedoPanel accountId={accountId} catalogItemUuid={catalogItemUuid} redo={redo} />
    </div>
  );
};

export const ReleasePostsDateRedo = TypedMemo(ReleasePostsDateRedoComponent);
